// "How it works", 3-step strip on dark navy. High-level order flow so a
// first-time visitor understands the path from cart to lab bench.
const STEPS = [
  {
    n: "01",
    title: "Choose your format",
    body: "Pen kit for ready-to-use dosing, or raw vial for lowest cost per mg. Every product ships with a public COA.",
  },
  {
    n: "02",
    title: "Pay in crypto or by bank",
    body: "Checkout supports pay-by-bank (rolling out) and multiple stablecoins. Verified inline, no third-party redirect for account creation.",
  },
  {
    n: "03",
    title: "Track & verify",
    body: "Cold-chain dispatch within 1 business day. Enter the 8-character code on your box to confirm the lot on arrival.",
  },
];

export default function HowItWorks() {
  return (
    <section
      className="border-b border-white/5 bg-navy text-white"
      data-testid="how-it-works"
    >
      <div className="container-pd py-16 lg:py-24">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="label-mono !text-brandbluelight">§ Order flow</p>
            <h2 className="mt-3 font-heading text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl">
              How it works.
            </h2>
          </div>
          <p className="max-w-md text-sm text-white/60">
            Three steps from cart to lab bench. No account creation gate, no
            multi-week verification cycle, email confirmation at checkout is
            all we need.
          </p>
        </div>

        <ol className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((s) => (
            <li
              key={s.n}
              className="relative rounded-lg border border-white/10 bg-white/[0.03] p-6"
              data-testid={`how-step-${s.n}`}
            >
              <span className="font-mono text-[10px] tracking-[0.18em] text-brandbluelight">
                STEP {s.n}
              </span>
              <p className="mt-4 font-heading text-xl font-black leading-tight">
                {s.title}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-white/60">
                {s.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
